import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

@Injectable()
export class SettingsService {

  settings:Settings = {
    themeUrl: 'assets/css/colors/default.css',
    theme: 'default'
  }

  constructor(@Inject(DOCUMENT) private _document) {
    this.loadSettings();
  }

  saveSettings(){

    localStorage.setItem('settings',JSON.stringify(this.settings))
  }

  loadSettings(){

    if(localStorage.getItem('settings'))
      this.settings = JSON.parse(localStorage.getItem('settings'));
    
    this.applyTheme(this.settings.theme);
  }

  applyTheme(theme:string){

    let url = `assets/css/colors/${theme}.css`
    this._document.getElementById('theme').setAttribute('href',url);

    this.settings.theme = theme;
    this.settings.themeUrl = url;
    this.saveSettings();

  }

}

interface Settings{
  themeUrl:string;
  theme:string;
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/services/settings/settings.service.ts